"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = require("./style");
var _AdvertisingPlaceholder = _interopRequireDefault(require("../AdvertisingPlaceholder"));
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var AdvertisingSlot = function AdvertisingSlot() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AdvertisingPlaceholder["default"], {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Advertising, {
      id: _constants.ADVERTISING_SLOT,
      "data-testid": _constants.ADVERTISING_SLOT
    })
  });
};
var _default = exports["default"] = AdvertisingSlot;